exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-a44ce6c2]{margin-bottom:54px;height:100%;padding:9px 9px 18px;background-color:#ececec;border-radius:4px;-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}@media only screen and (min-width:760px){.layout[data-v-a44ce6c2]{margin-bottom:54px;padding:18px 36px 27px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a44ce6c2","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/newprogram/components/layout/Layout.vue
// module id = 5bcde6821dc8c9a7b171
// module chunks = 10